/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Messaging_Bots_Admin_Title5Inputs */

const en_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin dashboard`)
};

const ar_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لوحة الإدارة`)
};

const bn_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`অ্যাডমিন ড্যাশবোর্ড`)
};

const de_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Admin-Dashboard`)
};

const es_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel de administración`)
};

const fr_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tableau de bord admin`)
};

const pt_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Painel de administração`)
};

const zh_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理后台`)
};

const tr_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yönetim paneli`)
};

const ru_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Админ-панель`)
};

const pl_svc_messaging_bots_admin_title5 = /** @type {(inputs: Svc_Messaging_Bots_Admin_Title5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Panel administratora`)
};

/**
* | output |
* | --- |
* | "Admin dashboard" |
*
* @param {Svc_Messaging_Bots_Admin_Title5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_messaging_bots_admin_title5 = /** @type {((inputs?: Svc_Messaging_Bots_Admin_Title5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Messaging_Bots_Admin_Title5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_messaging_bots_admin_title5(inputs)
	if (locale === "bn") return bn_svc_messaging_bots_admin_title5(inputs)
	if (locale === "de") return de_svc_messaging_bots_admin_title5(inputs)
	if (locale === "es") return es_svc_messaging_bots_admin_title5(inputs)
	if (locale === "fr") return fr_svc_messaging_bots_admin_title5(inputs)
	if (locale === "pt") return pt_svc_messaging_bots_admin_title5(inputs)
	if (locale === "zh") return zh_svc_messaging_bots_admin_title5(inputs)
	if (locale === "tr") return tr_svc_messaging_bots_admin_title5(inputs)
	if (locale === "ru") return ru_svc_messaging_bots_admin_title5(inputs)
	if (locale === "pl") return pl_svc_messaging_bots_admin_title5(inputs)
	return en_svc_messaging_bots_admin_title5(inputs)
});
export { svc_messaging_bots_admin_title5 as "svc_messaging-bots_ADMIN_title" }